import {
  Box,
  Button,
  Dialog,
  Grid,
  IconButton,
  SelectChangeEvent,
  Theme,
  Typography,
} from '@mui/material';
import { Formik, useField, useFormikContext, validateYupSchema, yupToFormErrors } from 'formik';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MFTextField } from '../../lib/formik';
import UseRadioGroup from '../../lib/formik/Radio';
import { RootStateType } from '../../redux-store/reducers';
import {
  nonIndividualMdmsFatca,
  nonIndividualMdmsQuestionsFatca,
  nonIndividualQuestionsFatca,
  Fatcadetails,
  Applicant,
  individuals_Poa_nonIndividuals_Documents,
  ApplicationProps,
  Broker,
  tinValidationProps,
  tinCountriesList,
  tinValidateResponse,
  DocumentType,
  FatcaMdms,
} from '../../redux-store/types/api-types';
import { ProceedSaveLater, SubHeading } from '../investors/components';
import { DatePicker } from '../../lib/formik/DatePicker';
import {
  FatcaMdmsData,
  nonIndividualFormValidForSubmission,
  updateApplication,
} from '../../redux-store/actions/application';
import { useHistory, useLocation } from 'react-router';
import {
  applicationComparison,
  checkIfApplicationIsNonIndividualPOA,
  getCurrentStep,
  navigateToNextStep,
  removeSingleQuote,
  shouldValidateUponSaveLater,
  statusRoleBased,
  checkValidationBasedOnDate,
  getQuestionId,
  getValueByPath,
  ifTinVerificationApplicable,
  tinDocumentCheck,
} from '../../utils/utilityFunctions';
import MFSelectField from '../../lib/formik/SelectField';
import { SxProps } from '@mui/system';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';
import ControllingPerson from './fatca_components';
import { showError } from '../../redux-store/actions/auth';
import { nonIndividualFatcaSchema } from '../../utils/schema';
import updateVisibility from '../../utils/fatcaUtils';
import {
  RiskProfileEnabled,
  SAVE_LATER_VALIDATION_CHECK,
  USER_ROLES,
  addressTypesMasters,
  docInvalidCheck,
  IndexToQuestionMapping,
  QuestionToIndexMapping,
  // RiskProfileEnabled,
  tinCode,
  NewIndexToQuestionMapping,
  gamblingValidationDate,
  NewQuestionToIndexMapping,
  // USER_ROLES,
} from '../../utils/constant';
import { fatcaErrors } from '../../redux-store/middleware';
import { mdmsCountriesList, togglerType } from '../../redux-store/types/mdms';
import { useSnackbar } from 'notistack';
import {
  useFeatureToggles,
  useMdmsBrokerListData,
  useMdmsCountryData,
  useMdmsDocumentData,
  useMdmsFatcaData,
  useMdmsRiskProfileData,
  useMdmsTopUpDocumentData,
} from '../../utils/useDataMdms';
import FieldValidationNote from '../investors/FieldValidationNote';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { TinVerificationComponent } from '../commonComponents';
import { getTinCountriesList, validateTin } from '../../redux-store/actions/onBoarding';
import { doc, document_object } from '../investors/documentDetails';

export interface Values {
  applicants: {
    fatcadetail: nonIndividualMdmsQuestionsFatca;
    typeOfAddressProvidedAtKRA: string;
    tinValidation: tinValidationProps[];
    documents: doc[];
  }[];
  saveType: string;
  _applicants: Partial<Applicant>[];
}
export function SectionHeader({ value }: { value: string }): JSX.Element {
  return (
    <Typography
      sx={{
        color: '#57B6BA',
        fontSize: '20px',
        fontWeight: 500,
        fontFamily: 'Poppins',
        letterSpacing: '0.96px',
        lineHeight: '30px',

        mb: 2,
        py: 1,
        width: '100%',
      }}>
      {value}
    </Typography>
  );
}

export const resetQ = (data: nonIndividualQuestionsFatca, baseQId: string): void => {
  if (
    data?.id
      .replace('Q', '')
      .localeCompare(baseQId.replace('Q', ''), undefined, { numeric: true, sensitivity: 'base' }) ==
    1
  ) {
    // console.log('Question id: ', data.id, ' is more than: ', baseQId);
    //data.answer = '';
    if (data.question_type == 'group') {
      data.isVisible = false;
      data.sub_questions?.forEach((_qns) => resetQ(_qns, baseQId));
    } else {
      data.isVisible = false;
    }
  } else {
    if (data.question_type == 'group') {
      // need to check for sub questions also
      data.sub_questions?.forEach((_qns) => resetQ(_qns, baseQId));
    }
    //console.log('Question id: ', data.id, ' is less than original id: ', baseQId);
  }
};
export const setVisibility = (
  inputQId: string,
  q: nonIndividualQuestionsFatca,
  formValues: nonIndividualMdmsQuestionsFatca
): void => {
  if (q.id === inputQId) {
    q.isVisible = true;
    if (q.answer) {
      updateVisibility(q.answer, q, formValues);
    }
  } else if (q.question_type === 'group') {
    q.sub_questions?.forEach((_qns) => setVisibility(inputQId, _qns, formValues));
  }
};

export const getSubQuestionsIndex = (
  indexArr: string[],
  indexVal = '',
  schema = false
): string | void => {
  const subIndex = indexVal;
  if (indexArr.length === 1) {
    return schema
      ? `fatcadetail[${Number(indexArr[0]) - 1}]${subIndex}`
      : `fatcadetail.${Number(indexArr[0]) - 1}${subIndex}`;
  }
  if (indexArr.length > 1) {
    const subIndexVal = schema
      ? `.sub_questions[${Number(indexArr.pop()) - 1}]${subIndex}`
      : `.sub_questions.${Number(indexArr.pop()) - 1}${subIndex}`;
    return getSubQuestionsIndex(indexArr, subIndexVal, schema);
  }
};

export function SingleChoiceRadio({
  data,
  values,
  formValuesIndex,
  questionId,
  disabled,
}: {
  data: Partial<nonIndividualMdmsFatca>;
  values: nonIndividualMdmsQuestionsFatca;
  formValuesIndex: number;
  questionId: string;
  disabled: boolean;
}): JSX.Element {
  const { setFieldValue } = useFormikContext();
  const singleChoiceRadioFieldName = questionId.split('Q')[1].split('.');
  const singleChoiceRadio_FieldName = getSubQuestionsIndex(singleChoiceRadioFieldName);
  const { application } = useSelector((state: RootStateType) => state.application);
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          pb: 3,
          pt: 1,
          fontFamily: 'Work Sans,sans-serif',
        }}>
        <Typography sx={{ fontWeight: 600, fontSize: 16 }}>{data.question_order}</Typography>
        <Typography
          sx={{
            pl: 1,
            fontWeight: 400,
            fontSize: 16,
          }}>
          {data.isMandatory === 'true' ? data.question_text + ' *' : data.question_text}
        </Typography>
      </Box>
      {data.options && (
        <Grid xs={12} sx={{ pl: 3, pb: 2 }}>
          <UseRadioGroup
            name={`applicants.${formValuesIndex}.${singleChoiceRadio_FieldName}.answer`}
            items={data.options.map((option) => ({
              label: option.label,
              value: option.label,
            }))}
            onChange={({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
              setFieldValue(
                `applicants.${formValuesIndex}.${singleChoiceRadio_FieldName}.answer`,
                value
              );
              if (tinDocumentCheck(questionId, application?.createdAt || '')) {
                setFieldValue(
                  `applicants.${formValuesIndex}.tinValidation.${
                    !checkValidationBasedOnDate(
                      application?.createdAt || '',
                      gamblingValidationDate
                    )
                      ? QuestionToIndexMapping[questionId] % 4
                      : NewQuestionToIndexMapping[questionId]
                  }`,
                  {
                    isTinVerified: value === 'No' ? false : null,
                  }
                );
              }
              updateVisibility(value, data, values);
            }}
            disabled={disabled}
          />
        </Grid>
      )}
    </>
  );
}
export function Info({ order, text }: { order: string; text: string }): JSX.Element {
  return (
    <>
      <Typography
        sx={{ fontFamily: 'Work Sans,sans-serif', fontWeight: 400, fontSize: '15px' }}
        component="span">
        {order}
      </Typography>
      <Typography
        sx={{
          pl: 1,
          fontFamily: 'Work Sans,sans-serif',
          fontWeight: 400,
          fontSize: '15px',
        }}
        component="span">
        {text}
      </Typography>
    </>
  );
}

export function BorderedTextField({
  applicantsIndex,
  questionId,
  label,
  placeHolder,
  sx = {},
  isMandatory,
  disabled,
}: {
  applicantsIndex: number;
  questionId: string;
  label?: string;
  placeHolder: string;
  sx?: SxProps<Theme>;
  isMandatory: string;
  disabled: boolean;
  // section?: number | null;
}): JSX.Element {
  const fieldName = questionId.split('Q')[1].split('.');
  const { setFieldValue } = useFormikContext();

  const { application } = useSelector((state: RootStateType) => state.application);
  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const fname = questionId.split('Q')[1].split('.');
    setFieldValue(
      `applicants.${applicantsIndex}.${getSubQuestionsIndex(fname)}.answer`,
      event.target.value
    );
    // if (ifTinVrification) {
    const section = checkValidationBasedOnDate(application?.createdAt || '', gamblingValidationDate)
      ? NewQuestionToIndexMapping[questionId]
      : QuestionToIndexMapping[questionId] % 4;
    setFieldValue(`applicants.${applicantsIndex}.tinValidation.${section}.isTinVerified`, null);
    // }
  }

  return (
    <MFTextField
      name={`applicants.${applicantsIndex}.${getSubQuestionsIndex(fieldName)}.answer`}
      label={label && (isMandatory === 'true' ? label + ' *' : label)}
      onChange={handleChange}
      // }}
      placeholder={placeHolder}
      sx={sx}
      disabled={disabled}
    />
  );
}

export function OpenTextField({
  text,
  applicantsIndex,
  questionId,
  placeHolder,
  isMandatory,
  disabled,
}: {
  text: string;
  applicantsIndex: number;
  questionId: string;
  placeHolder: string;
  isMandatory: string;
  disabled: boolean;
}): JSX.Element {
  const openTextFieldName = questionId.split('Q')[1].split('.');
  return (
    <>
      <Typography
        sx={{
          pl: { xs: 0, sm: 3 },
          pt: 3,
          fontFamily: 'Work Sans,sans-serif',
          fontWeight: 400,
          fontSize: 16,
        }}>
        {isMandatory === 'true' ? text + ' *' : text}
      </Typography>
      <Grid xs={12} sm={6} sx={{ pb: { xs: 1, sm: 0 }, pl: { xs: 0, sm: 3 }, pt: 2 }}>
        <MFTextField
          name={`applicants.${applicantsIndex}.${getSubQuestionsIndex(openTextFieldName)}.answer`}
          placeholder={placeHolder}
          sx={{
            '&.MuiInputBase-root': {
              position: 'relative',
              border: 0,
              borderBottom: '1px solid #ccc',
              fontSize: 16,
            },
          }}
          disabled={disabled}
        />
      </Grid>
    </>
  );
}

export function FatcaDatePicker({
  applicantsIndex,
  questionId,
  label,
  isMandatory,
  disabled,
}: {
  applicantsIndex: number;
  questionId: string;
  label: string;
  isMandatory: string;
  disabled: boolean;
}): JSX.Element {
  const fatcaDatePickerFieldName = questionId.split('Q')[1].split('.');
  return (
    <DatePicker
      label={isMandatory === 'true' ? label + ' *' : label}
      inputLabelStyles={{
        transform: 'unset',
        fontSize: 14,
        fontWeight: 500,
        color: 'rgba(0,0,0,0.7)',
      }}
      placeholder={'DD/MM/YYYY'}
      name={`applicants.${applicantsIndex}.${getSubQuestionsIndex(
        fatcaDatePickerFieldName
      )}.answer`}
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      disabled={disabled}
    />
  );
}

export function SingleChoiceDropdown({
  applicantsIndex,
  questionId,
  label,
  options,
  isMandatory,
  data,
  values,
  disabled,
  nationalityDropdown,
}: // key,
{
  applicantsIndex: number;
  questionId: string;
  label: string;
  options: {
    id: number;
    label: string;
    value?: string;
    showQs?: string[];
    type: string;
  }[];
  isMandatory: string;
  data: Partial<nonIndividualMdmsFatca>;
  values: nonIndividualMdmsQuestionsFatca;
  disabled: boolean;
  nationalityDropdown: mdmsCountriesList[];
  // key: string;
}): JSX.Element {
  const { setFieldValue } = useFormikContext();
  const SingleChoiceDropdownFieldName = questionId.split('Q')[1].split('.');
  const SingleChoiceDropdown_FieldName = `applicants.${applicantsIndex}.${getSubQuestionsIndex(
    SingleChoiceDropdownFieldName
  )}.answer`;
  const { application } = useSelector((state: RootStateType) => state.application);
  return (
    <MFSelectField
      name={SingleChoiceDropdown_FieldName}
      label={isMandatory === 'true' ? label + ' *' : label}
      items={options.map((option) => ({
        key: option.label,
        value: option.value ?? option.label,
      }))}
      onChange={({ target: { value } }: SelectChangeEvent<unknown>) => {
        setFieldValue(SingleChoiceDropdown_FieldName, value);
        if (
          checkValidationBasedOnDate(application?.createdAt || '', gamblingValidationDate) &&
          ['Q2.1', 'Q2.2', 'Q2.3'].includes(questionId)
        ) {
          setFieldValue(`applicants.${applicantsIndex}.tinValidation.0.isTinVerified`, null);
        }
        options.forEach((option) => {
          if (option.showQs) {
            updateVisibility(value as string, data, values);
          }
        });
      }}
      disabled={disabled}
    />
  );
}

export function SearchableSelectDropdown({
  applicantsIndex,
  questionId,
  label,
  options,
  isMandatory,
  data,
  values,
  disabled,
  nationalityDropdown,
  tinCountries,
  ifTinVrification = false,
}: // key,
{
  applicantsIndex: number;
  questionId: string;
  label: string;
  options: {
    id: number;
    label: string;
    showQs?: string[];
    type: string;
    value?: string;
  }[];
  isMandatory: string;
  data: Partial<nonIndividualMdmsFatca>;
  values: nonIndividualMdmsQuestionsFatca;
  disabled: boolean;
  nationalityDropdown: mdmsCountriesList[];
  tinCountries?: tinCountriesList[];
  ifTinVrification?: boolean;
  // key: string;
}): JSX.Element {
  const { setFieldValue, values: formValue } = useFormikContext();
  const SingleChoiceDropdownFieldName = questionId.split('Q')[1].split('.');
  const SingleChoiceDropdown_FieldName = `applicants.${applicantsIndex}.${getSubQuestionsIndex(
    SingleChoiceDropdownFieldName
  )}.answer`;
  const { application } = useSelector((state: RootStateType) => state.application);
  const [field, meta, helpers] = useField(SingleChoiceDropdown_FieldName);
  const [field2, meta2, helpers2] = useField(
    `applicants.${applicantsIndex}.tinValidation.${
      !checkValidationBasedOnDate(application?.createdAt || '', gamblingValidationDate)
        ? QuestionToIndexMapping[questionId] % 4
        : NewQuestionToIndexMapping[questionId]
    }.isTinVerified`
  );
  const IsentityCountryOfResidense = 'entityCountryOfResidense' === data.backend_key;
  return (
    <SearchableSelect
      name={SingleChoiceDropdown_FieldName}
      label={isMandatory === 'true' ? label + ' *' : label}
      items={
        ['entityCountryOfResidense', 'eIIssuingCountry'].includes(data.backend_key || '')
          ? tinCountries
              ?.filter((e) => {
                if (IsentityCountryOfResidense) {
                  return e.countryName.toLowerCase() !== 'india';
                }
                return true;
              })
              .map((nationality) => ({
                key: nationality.countryName,
                value: nationality.countryName,
              })) || []
          : ['Q6.2.6', 'Q9.2.6', 'Q6.1.7', 'Q9.1.7'].includes(questionId)
          ? tinCountries?.map((nationality) => ({
              key: nationality.countryName,
              value: nationality.countryName,
            })) || []
          : options.map((option) => ({
              key: option.label,
              value: option.value ?? option.label,
            }))
      }
      onChange={({ target: { value } }: SelectChangeEvent<unknown>) => {
        // setFieldValue(SingleChoiceDropdown_FieldName, value);
        // e.stopPropagation();
        // const value = value;
        helpers.setValue(value);
        if (
          checkValidationBasedOnDate(application?.createdAt || '', gamblingValidationDate) &&
          ['Q2.1', 'Q2.2', 'Q2.3'].includes(questionId)
        ) {
          setFieldValue(`applicants.${applicantsIndex}.tinValidation.0.isTinVerified`, null);
        }
        options.forEach((option) => {
          if (option.showQs) {
            updateVisibility(value as string, data, values);
          }
          if (ifTinVrification) {
            helpers2.setValue(null);
          }
        });
      }}
      disabled={disabled}
    />
  );
}
export function SingleChoiceDropdownWithInfo({
  applicantsIndex,
  questionId,
  label,
  options,
  isMandatory,
  data,
  values,
  disabled,
}: {
  applicantsIndex: number;
  questionId: string;
  label: string;
  options: {
    id: number;
    label: string;
    showQs?: string[];
    type: string;
  }[];
  isMandatory: string;
  data: Partial<nonIndividualMdmsFatca>;
  values: nonIndividualMdmsQuestionsFatca;
  disabled: boolean;
}): JSX.Element {
  const { setFieldValue } = useFormikContext();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const SingleChoiceDropdownWithInfo = questionId.split('Q')[1].split('.');
  const SingleChoiceDropdownWithInfo_FieldName = `applicants.${applicantsIndex}.${getSubQuestionsIndex(
    SingleChoiceDropdownWithInfo
  )}.answer`;

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'baseline' }}>
        <MFSelectField
          name={SingleChoiceDropdownWithInfo_FieldName}
          label={isMandatory === 'true' ? label + ' *' : label}
          items={options.map((option) => ({
            key: option.label,
            value: option.label,
          }))}
          onChange={({ target: { value } }: SelectChangeEvent<unknown>) => {
            setFieldValue(SingleChoiceDropdownWithInfo_FieldName, value);
            options.forEach((option) => {
              if (option.showQs) {
                updateVisibility(value as string, data, values);
              }
            });
          }}
          disabled={disabled}
        />
        <InfoOutlinedIcon
          color="info"
          fontSize="small"
          onClick={handleOpen}
          sx={{ position: 'relative', top: 4, left: 5 }}
        />
      </Box>
      <Dialog
        onClose={handleClose}
        open={open}
        sx={{
          '.MuiPaper-root ': {
            maxWidth: 800,
            p: { xs: 2, sm: '15px 5px 35px' },
            borderRadius: '10px',
            height: 'unset',
            overflowY: 'auto',
          },
        }}>
        <IconButton onClick={handleClose} sx={{ alignSelf: 'flex-end' }}>
          <CloseIcon fontSize="medium" />
        </IconButton>
        <Box
          sx={{
            width: { xs: '100%', sm: '90%' },
            mx: 'auto',
            '.MuiTypography-root': {
              textAlign: 'start',
              fontFamily: 'Work Sans,sans-serif',
            },
          }}>
          <Typography sx={{ fontSize: 16, fontWeight: 400 }}>
            *If a TIN is unavailable, please provide the appropriate reason A, B or C as defined
            below:
          </Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }} component="span">
              Reason A –{' '}
            </Typography>
            The country where the Account Holder is liable to pay tax does not issue TINs to its
            residents.
          </Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }} component="span">
              Reason B –{' '}
            </Typography>
            The Account Holder is unable to obtain a TIN or equivalent number. (If this reason is
            selected, please explain why the Account Holder is unable to obtain a TIN in the box
            beside)
          </Typography>
          <Typography sx={{ fontSize: 16, fontWeight: 400, pt: 1 }}>
            <Typography sx={{ fontSize: 16, fontWeight: 500 }} component="span">
              Reason C –{' '}
            </Typography>
            No TIN is required because the tax residence jurisdiction that issued the TIN does not
            require a Financial Institution to collect and report the TIN
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              variant="contained"
              sx={{ minWidth: { xs: '170px', sm: '220px' }, mt: 3 }}
              onClick={handleClose}>
              Done
            </Button>
          </Box>
        </Box>
      </Dialog>
    </>
  );
}

export function Group({
  data,
  formValuesIndex,
  values,
  _applicants,
  disabled,
  nationalityDropdown,
  setValue,
  createdAt,
  tinVerification,
  handleVerification,
  tinCountries,
  documents,
  loading = false,
  formVal,
  toggler,
}: {
  data: Partial<nonIndividualQuestionsFatca>;
  formValuesIndex: number;
  values: nonIndividualMdmsQuestionsFatca;
  _applicants: Partial<Applicant>[];
  disabled: boolean;
  nationalityDropdown: mdmsCountriesList[];
  setValue: (values: React.SetStateAction<Values>, shouldValidate?: boolean) => void;
  createdAt: string;
  tinVerification: tinValidationProps[] | null;
  handleVerification?: any;
  tinCountries?: tinCountriesList[];
  documents: doc[];
  loading?: boolean;
  formVal?: Values;
  toggler: togglerType;
}): JSX.Element {
  return (
    <>
      {data.isVisible && data.section_header && <SectionHeader value={data.section_header} />}
      {data.isVisible && data.showHeader && data.header && (
        <SubHeading sx={{ marginTop: '23px', marginBottom: '20px' }}>{data.header}</SubHeading>
      )}
      {data.isVisible && data.showHeader && data.question_order === '' && data.question_text && (
        <Typography
          sx={{
            fontFamily: 'Work Sans,sans-serif',
            fontWeight: 400,
            fontSize: '16px',
            pt: 1,
            pb: 1,
            width: '100%',
          }}>
          {data.question_text}
        </Typography>
      )}
      {data.isVisible && data.question_order && data.question_type === 'group' && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            pt: 1,
            fontFamily: 'Work Sans,sans-serif',
          }}>
          <Typography sx={{ fontWeight: 400, fontSize: '16px' }}>{data.question_order}</Typography>
          <Typography
            sx={{
              pl: 1,
              fontWeight: 400,
              fontSize: '16px',
            }}>
            {data.question_text}
          </Typography>
        </Box>
      )}
      {data.isVisible &&
        data.sub_questions?.map((sub_qns, sub_index) => {
          if (sub_qns.isVisible && sub_qns.question_type === 'group') {
            return (
              <Group
                data={sub_qns}
                formValuesIndex={formValuesIndex}
                values={values}
                _applicants={_applicants}
                disabled={disabled}
                nationalityDropdown={nationalityDropdown}
                setValue={setValue}
                createdAt={createdAt}
                tinVerification={tinVerification}
                handleVerification={handleVerification}
                tinCountries={tinCountries}
                documents={documents}
                formVal={formVal}
                toggler={toggler}
              />
            );
          }
          return (
            <React.Fragment key={sub_index}>
              {sub_qns.isVisible && sub_qns.question_type === 'single_choice_radio' && (
                <>
                  <Grid xs={12} sm={12} sx={{ pt: 2 }}>
                    <SingleChoiceRadio
                      data={sub_qns}
                      values={values}
                      formValuesIndex={formValuesIndex}
                      questionId={sub_qns.id}
                      disabled={disabled}
                    />
                  </Grid>
                  {checkValidationBasedOnDate(
                    createdAt || '',
                    toggler?.dateFeatureToggles?.tin_declaration_validation_date
                  ) &&
                    ifTinVerificationApplicable(sub_qns.id, createdAt || '') && (
                      // <Grid item xs={12} sx={{ pt: 2 }}>
                      <TinVerificationComponent
                        fieldname={`applicant.${formValuesIndex}.fatcaDetail.taxId${getQuestionId(
                          sub_qns.id
                        )}`}
                        isFieldDisabled={disabled}
                        setValues={setValue}
                        index={formValuesIndex}
                        formvalues={values}
                        targetField={`taxId${getQuestionId(sub_qns.id)}`}
                        createdAt={createdAt}
                        loading={false}
                        isTinVerified={
                          tinVerification
                            ? tinVerification[
                                Number(
                                  checkValidationBasedOnDate(
                                    createdAt || '',
                                    gamblingValidationDate
                                  )
                                    ? NewQuestionToIndexMapping[sub_qns.id]
                                    : QuestionToIndexMapping[sub_qns.id] % 4
                                )
                              ]?.isTinVerified
                            : null
                        }
                        handleVerification={handleVerification}
                        tinVerification={tinVerification}
                        tinIndex={
                          checkValidationBasedOnDate(createdAt || '', gamblingValidationDate)
                            ? NewQuestionToIndexMapping[sub_qns.id]
                            : QuestionToIndexMapping[sub_qns.id] % 4
                        }
                        documents={documents}
                        formVal={formVal}
                        isDocumentCheck={tinDocumentCheck(sub_qns.id, createdAt || '')}
                      />
                      // </Grid>
                    )}
                </>
              )}
              {sub_qns.isVisible && sub_qns.question_type === 'info' && (
                <Box
                  sx={{
                    pt: 1,
                    pl: ['1.', '2.', '3.', '4.', '5.', '6.', ''].includes(sub_qns.question_order)
                      ? 0
                      : 2.5,
                  }}>
                  <Info order={sub_qns.question_order} text={sub_qns.question_text} />
                </Box>
              )}
              {sub_qns.isVisible && sub_qns.question_type === 'bordered_text_field' && (
                <>
                  <Grid item xs={12} sm={6} sx={{ pt: 2 }}>
                    <BorderedTextField
                      applicantsIndex={formValuesIndex}
                      questionId={sub_qns.id}
                      label={sub_qns.question_text}
                      placeHolder={sub_qns.placeholder || 'Please enter text here'}
                      isMandatory={sub_qns.isMandatory}
                      disabled={disabled}
                      // section={sub_qns.section || null}
                    />
                  </Grid>
                  {checkValidationBasedOnDate(
                    createdAt || '',
                    toggler?.dateFeatureToggles?.tin_declaration_validation_date
                  ) &&
                    ifTinVerificationApplicable(sub_qns.id, createdAt || '') && (
                      <TinVerificationComponent
                        fieldname={`applicant.${formValuesIndex}.fatcaDetail.taxId${getQuestionId(
                          sub_qns.id
                        )}`}
                        isFieldDisabled={disabled}
                        setValues={setValue}
                        index={formValuesIndex}
                        formvalues={values}
                        targetField={'taxId2'}
                        createdAt={createdAt}
                        loading={loading}
                        isTinVerified={(() => {
                          if (!tinVerification) return null;
                          const idx = checkValidationBasedOnDate(
                            createdAt || '',
                            gamblingValidationDate
                          )
                            ? NewQuestionToIndexMapping[sub_qns.id]
                            : Number(QuestionToIndexMapping[sub_qns.id] % 4);
                          return tinVerification[idx]?.isTinVerified ?? null;
                        })()}
                        handleVerification={handleVerification}
                        tinVerification={tinVerification}
                        tinIndex={
                          checkValidationBasedOnDate(createdAt || '', gamblingValidationDate)
                            ? NewQuestionToIndexMapping[sub_qns.id]
                            : QuestionToIndexMapping[sub_qns.id] % 4
                        }
                        documents={documents}
                        formVal={formVal}
                        isDocumentCheck={
                          tinDocumentCheck(sub_qns.id, createdAt || '') &&
                          getValueByPath(values, sub_qns.id).answer === 'no'
                        }
                      />
                    )}
                </>
              )}
              {sub_qns.isVisible && sub_qns.question_type === 'open_text_field' && (
                <>
                  <Grid item xs={12} sm={6} sx={{ pt: 2 }}>
                    <BorderedTextField
                      applicantsIndex={formValuesIndex}
                      questionId={sub_qns.id}
                      placeHolder={sub_qns.placeholder || 'Please enter text here'}
                      sx={{
                        '&.MuiInputBase-root': {
                          position: 'relative',
                          border: 0,
                          borderBottom: '1px solid #ccc',
                          fontSize: 16,
                          pt: 4,
                        },
                      }}
                      isMandatory={sub_qns.isMandatory}
                      disabled={disabled}
                    />
                  </Grid>
                </>
              )}
              {sub_qns.isVisible && sub_qns.question_type === 'single_choice_dropdown' && (
                <Grid item xs={12} sm={6} sx={{ pt: 2 }}>
                  <SingleChoiceDropdown
                    applicantsIndex={formValuesIndex}
                    questionId={sub_qns.id}
                    label={sub_qns.question_text}
                    options={sub_qns.options || []}
                    isMandatory={sub_qns.isMandatory}
                    data={sub_qns}
                    values={values}
                    disabled={disabled}
                    nationalityDropdown={nationalityDropdown}
                  />
                </Grid>
              )}
              {/* {sub_qns.isVisible && sub_qns.question_type === 'single_choice_dropdown_search' && (
                <Grid item xs={12} sm={6} sx={{ pt: 2 }}>
                  <SingleChoiceDropdownWithSearch
                    applicantsIndex={formValuesIndex}
                    questionId={sub_qns.id}
                    label={sub_qns.question_text}
                    options={sub_qns.options || []}
                    isMandatory={sub_qns.isMandatory}
                    data={sub_qns}
                    values={values}
                    disabled={disabled}
                  />
                </Grid>
              )} */}
              {sub_qns.isVisible && sub_qns.question_type === 'search_single_choice_dropdown' && (
                <>
                  <Grid item xs={12} sm={6} sx={{ pt: 2 }}>
                    <SearchableSelectDropdown
                      applicantsIndex={formValuesIndex}
                      questionId={sub_qns.id}
                      label={sub_qns.question_text}
                      options={sub_qns.options || []}
                      isMandatory={sub_qns.isMandatory}
                      data={sub_qns}
                      values={values}
                      disabled={disabled}
                      nationalityDropdown={nationalityDropdown}
                      tinCountries={tinCountries}
                      ifTinVrification={!!sub_qns.tinValidation}
                    />
                  </Grid>
                  {checkValidationBasedOnDate(
                    createdAt || '',
                    toggler?.dateFeatureToggles?.tin_declaration_validation_date
                  ) &&
                    ifTinVerificationApplicable(sub_qns.id, createdAt || '') && (
                      // <Grid item xs={12} sx={{ pt: 2 }}>
                      <TinVerificationComponent
                        fieldname={`applicant.${formValuesIndex}.fatcaDetail.taxId${getQuestionId(
                          sub_qns.id
                        )}`}
                        isFieldDisabled={disabled}
                        setValues={setValue}
                        index={formValuesIndex}
                        formvalues={values}
                        targetField={`taxId${getQuestionId(sub_qns.id)}`}
                        createdAt={createdAt}
                        loading={false}
                        isTinVerified={(() => {
                          if (!tinVerification) return null;
                          const idx = checkValidationBasedOnDate(
                            createdAt || '',
                            gamblingValidationDate
                          )
                            ? NewQuestionToIndexMapping[sub_qns.id]
                            : Number(QuestionToIndexMapping[sub_qns.id] % 4);
                          return tinVerification[idx]?.isTinVerified ?? null;
                        })()}
                        handleVerification={handleVerification}
                        tinVerification={tinVerification}
                        tinIndex={
                          checkValidationBasedOnDate(createdAt || '', gamblingValidationDate)
                            ? QuestionToIndexMapping[sub_qns.id] % 4
                            : NewQuestionToIndexMapping[sub_qns.id]
                        }
                        documents={documents}
                        formVal={formVal}
                        isDocumentCheck={
                          tinDocumentCheck(sub_qns.id, createdAt || '') &&
                          getValueByPath(values, sub_qns.id).answer === 'no'
                        }
                      />
                      // </Grid>
                    )}
                </>
              )}
              {sub_qns.isVisible && sub_qns.question_type === 'single_choice_dropdown_withInfo' && (
                <Grid item xs={12} sm={6} sx={{ pt: 2 }}>
                  <SingleChoiceDropdownWithInfo
                    applicantsIndex={formValuesIndex}
                    questionId={sub_qns.id}
                    label={sub_qns.question_text}
                    options={sub_qns.options || []}
                    isMandatory={sub_qns.isMandatory}
                    data={sub_qns}
                    values={values}
                    disabled={disabled}
                  />
                </Grid>
              )}
              {sub_qns.isVisible && sub_qns.question_type === 'date' && (
                <Grid xs={12} sm={6} sx={{ px: { xs: 0, sm: '30px' }, pt: 1 }}>
                  <FatcaDatePicker
                    applicantsIndex={formValuesIndex}
                    questionId={sub_qns.id}
                    label={sub_qns.question_text}
                    isMandatory={sub_qns.isMandatory}
                    disabled={disabled}
                  />
                </Grid>
              )}
              {sub_qns.isVisible && sub_qns.question_type === 'Controlling_person_details' && (
                <ControllingPerson
                  applicantsIndex={formValuesIndex}
                  header={sub_qns.header}
                  _applicants={_applicants}
                  questionText={sub_qns.question_text}
                  disabled={disabled}
                  nationalityDropdown={nationalityDropdown}
                />
              )}
            </React.Fragment>
          );
        })}
    </>
  );
}

// eslint-disable-next-line
const preFilling = (_fatca: Partial<nonIndividualQuestionsFatca>, name: string): any => {
  return {
    ..._fatca,
    sub_questions: _fatca.sub_questions?.map((item: Partial<nonIndividualQuestionsFatca>) => {
      if (item.backend_key && item.backend_key === 'entityName') {
        return {
          ...item,
          answer: name,
        };
      }
      if (item.backend_key && item.backend_key === 'declarationDate') {
        return {
          ...item,
          answer: new Date(),
        };
      }
      if (item.question_type === 'group' && item.sub_questions) {
        return preFilling(item, name);
      }
      return item;
    }),
  };
};

const assignAnsForInitialFatcaQns = (
  _fatca: Partial<nonIndividualQuestionsFatca>,
  existingFatcaDetails: Fatcadetails,
  fatca: nonIndividualMdmsQuestionsFatca
  // eslint-disable-next-line
): any => {
  return {
    ..._fatca,
    sub_questions: _fatca.sub_questions?.map((item: Partial<nonIndividualQuestionsFatca>) => {
      if (existingFatcaDetails[item.backend_key as keyof Fatcadetails] as string) {
        return {
          ...item,
          answer: existingFatcaDetails[item.backend_key as keyof Fatcadetails] as string,
        };
      }
      if (item.question_type === 'group' && item.sub_questions) {
        return assignAnsForInitialFatcaQns(item, existingFatcaDetails, fatca);
      }
      return item;
    }),
  };
};

const setVisibilityForInitialFatca = (
  _qns: Partial<nonIndividualQuestionsFatca>,
  fatca: nonIndividualMdmsQuestionsFatca
  // eslint-disable-next-line
): any => {
  return {
    ..._qns,
    sub_questions: _qns.sub_questions?.map((item: Partial<nonIndividualQuestionsFatca>) => {
      if (
        (item.question_type === 'single_choice_radio' ||
          item.question_type === 'single_choice_dropdown' ||
          item.question_type === 'search_single_choice_dropdown' ||
          item.question_type === 'single_choice_dropdown_withInfo') &&
        item.answer &&
        item.answer.length > 0 &&
        item.isVisible
      ) {
        updateVisibility(item.answer, item, fatca);
      }
      if (item.question_type === 'group' && item.sub_questions) {
        return setVisibilityForInitialFatca(item, fatca);
      }
      return item;
    }),
  };
};

export const AssignAnsAndVisibilityForInitialFatca = (
  fatca: nonIndividualMdmsQuestionsFatca,
  existingFatcaDetails: Fatcadetails
  // eslint-disable-next-line
): any => {
  const assignAns = fatca?.map((_fatca) => {
    if (existingFatcaDetails[_fatca.backend_key as keyof Fatcadetails]) {
      return {
        ..._fatca,
        answer: existingFatcaDetails[_fatca.backend_key as keyof Fatcadetails] as string,
      };
    }
    if (_fatca.question_type === 'group' && _fatca.sub_questions) {
      return assignAnsForInitialFatcaQns(_fatca, existingFatcaDetails, fatca);
    }
    return _fatca;
  });
  const finalInitialFatcaQns = assignAns?.map((_q) => {
    if (
      (_q.question_type === 'single_choice_radio' ||
        _q.question_type === 'single_choice_dropdown' ||
        _q.question_type === 'search_single_choice_dropdown' ||
        _q.question_type === 'single_choice_dropdown_withInfo') &&
      _q.answer &&
      _q.answer.length > 0
    ) {
      updateVisibility(_q.answer, _q, assignAns);
    }
    if (_q.question_type === 'group' && _q.sub_questions) {
      return setVisibilityForInitialFatca(_q, assignAns);
    }
    return _q;
  });
  return finalInitialFatcaQns;
};

export function Fatca(): JSX.Element {
  const { application } = useSelector((store: RootStateType) => store.application);

  const [fatca, setFatca] = useState<nonIndividualMdmsQuestionsFatca>([]);
  const history = useHistory();
  const dispatch = useDispatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [loading, setLoading] = useState(false);
  const [documentsData, setDocumentsData] = useState<individuals_Poa_nonIndividuals_Documents[]>(
    []
  );
  const [topUpDocumentData, setTopUpDocumentData] = useState<
    individuals_Poa_nonIndividuals_Documents[]
  >([]);
  const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);
  const { enqueueSnackbar } = useSnackbar();
  // const { BrokerList } = useMdmsBrokerListData();
  const { countries } = useMdmsCountryData();
  const { riskProfile } = useMdmsRiskProfileData();
  const { Document } = useMdmsDocumentData();
  const { TopUpDocument } = useMdmsTopUpDocumentData();
  const fatcaName = useMdmsFatcaData();
  const { toggler } = useFeatureToggles();
  const location = useLocation();
  const path = location.pathname;
  const [tinCountries, setTinCountries] = useState<tinCountriesList[]>([]);

  useEffect(() => {
    (async function () {
      try {
        const res = (await dispatch(getTinCountriesList())) as unknown as tinCountriesList[];
        setTinCountries(res);
        if (fatcaName) {
          const response = (await dispatch(FatcaMdmsData(fatcaName))) as unknown as FatcaMdms;
          const clonedFatca = JSON.parse(JSON.stringify(response.fatca_questions));
          setFatca(clonedFatca);
        }
        setMdmsCountriesList(countries.countries);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [countries, fatcaName]);

  const fetchDocs = async function () {
    try {
      const { applicants = [] } = application || {};
      const getInvestorType = applicants[0]?.investorType?.toString();
      if (getInvestorType) {
        if (getInvestorType && Object.keys(Document).includes(getInvestorType)) {
          if (checkIfApplicationIsNonIndividualPOA(application as ApplicationProps)) {
            setDocumentsData(
              Document[`${getInvestorType}_poa`] as individuals_Poa_nonIndividuals_Documents[]
            );
            setTopUpDocumentData(
              TopUpDocument[`${getInvestorType}_poa`] as individuals_Poa_nonIndividuals_Documents[]
            );
          } else {
            setDocumentsData(
              Document[getInvestorType] as individuals_Poa_nonIndividuals_Documents[]
            );
            setTopUpDocumentData(
              TopUpDocument[getInvestorType] as individuals_Poa_nonIndividuals_Documents[]
            );
          }
        }
      }
    } catch (e) {
      console.error((e as Error).message);
    }
  };

  useEffect(() => {
    fetchDocs();
  }, [application, TopUpDocument, Document]);

  const { applicants = [] } = application || {};
  const initialValues: Values = useMemo(() => {
    return {
      applicants: applicants.map((applicant) => {
        const { fatcadetail: existingFatcaDetails = null, isTinVerified = [] } = applicant || {};
        return {
          fatcadetail: existingFatcaDetails
            ? AssignAnsAndVisibilityForInitialFatca(fatca, existingFatcaDetails)
            : fatca.map((_fatca) => {
                if (_fatca.backend_key === 'entityName') {
                  return {
                    ..._fatca,
                    answer: applicant.name || '',
                  };
                }
                if (_fatca.backend_key === 'declarationDate') {
                  return {
                    ..._fatca,
                    answer: new Date(),
                  };
                }
                if (_fatca.question_type === 'group' && _fatca.sub_questions) {
                  return preFilling(_fatca, applicant.name || '');
                }
                return _fatca;
              }),
          typeOfAddressProvidedAtKRA: applicant.typeOfAddressProvidedAtKRA || '',
          tinValidation:
            isTinVerified.length === 4
              ? isTinVerified.map((item) => ({ isTinVerified: item }))
              : [
                  {
                    isTinVerified: null,
                  },
                  {
                    isTinVerified: null,
                  },
                  {
                    isTinVerified: null,
                  },
                  {
                    isTinVerified: null,
                  },
                ],
          documents:
            typeof documentsData !== 'undefined'
              ? ((documentsData as individuals_Poa_nonIndividuals_Documents[]) || [])
                  .filter((doc, index) =>
                    [
                      'tin_declaration_1',
                      'tin_declaration_2',
                      'tin_declaration_3',
                      'tin_declaration_4',
                    ].includes(doc.documentType)
                  )
                  .map((doc: individuals_Poa_nonIndividuals_Documents, index: number) => {
                    const {
                      documentType,
                      documentName,
                      multipleFiles,
                      required,
                      options,
                      downloadTemplate,
                    } = doc;
                    const { documents: existingDocuments = [] } = applicant || {};
                    const docsOfCurrentDocType = existingDocuments
                      .filter((doc) => doc.documentType === documentType)
                      .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
                    return {
                      documentType: documentType,
                      documentName: documentName,
                      documentsList: docsOfCurrentDocType.length
                        ? docsOfCurrentDocType.map((doc, ind) => {
                            const {
                              documentName = '',
                              documentType = '',
                              documentId = '',
                              isActive = true,
                              file = undefined,
                            } = doc;
                            return {
                              documentType,
                              documentName,
                              documentId,
                              isActive,
                              file,
                              options,
                              required,
                              downloadTemplate,
                              uniqueKey: ('0'.toString() +
                                '-' +
                                index.toString() +
                                '-' +
                                ind.toString()) as string,
                              isVisible: true,
                            };
                          })
                        : [
                            {
                              documentType,
                              documentName,
                              required,
                              options,
                              downloadTemplate,
                              uniqueKey: ('0'.toString() +
                                '-' +
                                index.toString() +
                                '-' +
                                '0') as string,
                              isVisible: true,
                              ...document_object,
                            },
                          ],
                      required,
                      multipleFiles,
                      options,
                      downloadTemplate,
                    };
                  })
              : [],
        };
      }),
      saveType: 'save and proceed',
      _applicants: applicants,
    };
  }, [application, fatca, documentsData]);

  const assignAnswer = (
    subQns: Partial<nonIndividualQuestionsFatca>,
    _applicants: Partial<Applicant>[]
  ): Fatcadetails => {
    const controllingPerson = _applicants
      .map((applicant) => {
        if (applicant.fatcadetail?.controllingpersons) {
          return applicant.fatcadetail?.controllingpersons;
        }
      })
      .filter((ele) => ele)
      .flat();

    return subQns.sub_questions?.reduce((_prev, _curr: Partial<nonIndividualQuestionsFatca>) => {
      if (_curr.answer && _curr.isVisible && _curr.question_type !== 'Controlling_person_details') {
        return { ..._prev, [_curr.backend_key as string]: _curr.answer };
      }
      if (_curr.isVisible && _curr.question_type === 'Controlling_person_details') {
        return { ..._prev, [_curr.backend_key as string]: controllingPerson };
      }
      if (_curr.question_type === 'group' && _curr.sub_questions?.length) {
        return { ..._prev, ...assignAnswer(_curr, _applicants) };
      }
      return _prev;
      // eslint-disable-next-line
    }, {}) as any;
  };
  const resetAnswer = (
    subQns: Partial<nonIndividualQuestionsFatca>,
    _applicants: Partial<Applicant>[]
  ): Fatcadetails => {
    const controllingPerson = _applicants
      .map((applicant) => {
        if (applicant.fatcadetail?.controllingpersons) {
          return applicant.fatcadetail?.controllingpersons;
        }
      })
      .filter((ele) => ele)
      .flat();
    return subQns.sub_questions?.reduce((_prev, _curr: Partial<nonIndividualQuestionsFatca>) => {
      if (_curr.question_type === 'group' && _curr.sub_questions?.length) {
        return { ..._prev, ...resetAnswer(_curr, _applicants) };
      }
      return (
        _curr.backend_key && {
          ..._prev,
          [_curr.backend_key as string]:
            _curr.question_type === 'Controlling_person_details'
              ? controllingPerson.length
                ? controllingPerson.map((person) => ({ ...person, isActive: false }))
                : []
              : _curr.question_type === 'date'
              ? null
              : '',
        }
      );
      // eslint-disable-next-line
    }, {} as any) as any;
  };
  const validationPopUp = (
    fatca: nonIndividualQuestionsFatca,
    _applicants: Partial<Applicant>[],
    mdmsCountriesList: mdmsCountriesList[]
  ) => {
    const controllingPerson = _applicants
      .map((applicant) => {
        if (applicant.fatcadetail?.controllingpersons) {
          return applicant.fatcadetail?.controllingpersons;
        }
      })
      .flat()
      .filter((item) => item?.isActive);
    const nationalityDropdown = mdmsCountriesList.map((list) => list.nationality);
    const countryDropdown = mdmsCountriesList.map((list) => list.name);
    if (
      !fatca.answer &&
      fatca.isVisible &&
      fatca.backend_key &&
      fatca.isMandatory === 'true' &&
      fatca.question_type === 'single_choice_radio'
    ) {
      throw new fatcaErrors(`Please fill all the fields`);
    }
    if (
      fatca.isVisible &&
      fatca.isMandatory === 'true' &&
      fatca.question_type === 'Controlling_person_details' &&
      !controllingPerson.length
    ) {
      throw new fatcaErrors(`Please Add Controlling Person`);
    }
    if (
      fatca.isVisible &&
      fatca.isMandatory === 'true' &&
      fatca.question_type === 'Controlling_person_details' &&
      controllingPerson.length
    ) {
      controllingPerson.map((person) => {
        if (!countryDropdown.includes(person?.countryOfResidense || '')) {
          throw `Invalid Country Of Residense for ${person?.name} in Controlling Person`;
        }
        if (!nationalityDropdown.includes(person?.nationality || '')) {
          throw `Invalid Nationality for ${person?.name} in Controlling Person`;
        }
        if (!countryDropdown.includes(person?.issuingCountry || '')) {
          throw `Invalid issuing country for ${person?.name} in Controlling Person`;
        }
        if (!countryDropdown.includes(person?.countryOfBirth || '')) {
          throw `Invalid Country of Birth for ${person?.name} in Controlling Person`;
        }
      });
    }
    if (fatca.question_type === 'group' && fatca.sub_questions?.length) {
      fatca.sub_questions?.forEach((qun) => validationPopUp(qun, _applicants, mdmsCountriesList));
    }
  };

  const updatedDocApplicants = (
    exisitingApplicants: Partial<Applicant>[],
    documents: doc[]
  ): Partial<Applicant>[] => {
    const set = new Set(exisitingApplicants[0]?.documents?.map((item) => item.documentId) || []);
    return exisitingApplicants.map((applicant, index) => {
      const finalDocs = documents.map((doc) => {
        if (doc.documentsList.some((_documentCheck) => _documentCheck?.errorOnUpload)) {
          throw docInvalidCheck;
        }
        return doc.documentsList.filter((d) => d.documentId);
      });
      return {
        ...applicant,
        documents: finalDocs
          .flat()
          .filter((item) => !set.has(item.documentId))
          .map((doc) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { uniqueKey, required, errorOnUpload, ...rest } = doc;
            return rest;
          }),
      };
    }) as Partial<Applicant>[];
  };

  const handleSubmit = async (values: Values) => {
    try {
      const { applicants, saveType, _applicants } = values;
      setLoading(true);

      if (shouldValidateUponSaveLater(saveType)) {
        // fetchDocs();
        let risk;
        if (RiskProfileEnabled) {
          risk = riskProfile;
        }
        await nonIndividualFormValidForSubmission(
          application,
          risk,
          toggler,
          documentsData,
          topUpDocumentData,
          mdmsCountriesList,
          // BrokerList.broker_list as Broker[],
          true,
          role
        );
      }
      applicants.forEach((applicant) => {
        applicant.fatcadetail?.forEach((fatca) => {
          if (shouldValidateUponSaveLater(saveType)) {
            validationPopUp(fatca, _applicants, mdmsCountriesList);
          }
        });
      });
      const {
        applicants: exisitingApplicants = [],
        id,
        applicant1ReferenceId = '',
        currentStep,
        applicationNumber,
        topupApplicationNumber,
        isTopup,
        createdAt,
      } = application || {};

      const isNewFatca = checkValidationBasedOnDate(createdAt || '', gamblingValidationDate);
      const incrementCounter = getValueByPath(applicants[0].fatcadetail, 'Q6')?.isVisible ? 0 : 4;

      if (
        checkValidationBasedOnDate(
          createdAt || '',
          toggler?.dateFeatureToggles?.tin_declaration_validation_date || ''
        )
      ) {
        const tinValidation = values.applicants[0].tinValidation;

        if (isNewFatca) {
          const item = tinValidation[0];
          const isQ22Visible = getValueByPath(applicants[0].fatcadetail, 'Q2.4')?.isVisible;

          if (isQ22Visible && item.isTinVerified === null) {
            throw 'Please Verify Tin';
          }

          const docs = applicants[0].documents[0]?.documentsList || [];
          for (let ind = 0; ind < docs.length; ind++) {
            const _doc = docs[ind];
            const needsDoc = !_doc.documentId && item.isTinVerified === false && isQ22Visible;
            if (needsDoc) {
              throw `Please Upload ${_doc.documentName}`;
            }
          }
        } else {
          for (let index = 0; index < tinValidation.length; index++) {
            const item = tinValidation[index];

            const allVisible = IndexToQuestionMapping[index + incrementCounter].every(
              (id) => getValueByPath(applicants[0].fatcadetail, id).isVisible
            );

            if (allVisible && item.isTinVerified === null) {
              throw 'Please Verify Tin';
            }

            const docs = applicants[0].documents[index].documentsList;
            for (let ind = 0; ind < docs.length; ind++) {
              const _doc = docs[ind];

              const needsDoc =
                !_doc.documentId &&
                item.isTinVerified === false &&
                ((index === 2 &&
                  ['Q6.2.4', 'Q9.2.4'].some(
                    (q) =>
                      getValueByPath(applicants[0].fatcadetail, q)?.answer === 'No' &&
                      getValueByPath(applicants[0].fatcadetail, q)?.isVisible
                  )) ||
                  getValueByPath(
                    applicants[0].fatcadetail,
                    IndexToQuestionMapping[index + incrementCounter][0]
                  )?.isVisible);

              if (needsDoc) {
                throw `Please Upload ${_doc.documentName}`;
              }
            }
          }
        }
      }

      const newDoc = isNewFatca
        ? applicants[0].documents.filter((item, index) => {
            return (
              index === 0 &&
              getValueByPath(applicants[0].fatcadetail, 'Q2.4')?.isVisible &&
              values.applicants[0].tinValidation[0].isTinVerified === false
            );
          })
        : applicants[0].documents.filter((item, index) => {
            return (
              (getValueByPath(
                applicants[0].fatcadetail,
                IndexToQuestionMapping[index + incrementCounter][0]
              )?.isVisible ||
                (index === 2 &&
                  ['Q6.2.4', 'Q9.2.4'].some(
                    (item) => getValueByPath(applicants[0].fatcadetail, item)?.answer === 'No'
                  ))) &&
              values.applicants[0].tinValidation[index].isTinVerified == false
            );
          });

      const updatedApplicantsWithDoc = updatedDocApplicants(exisitingApplicants, newDoc);

      const updatedApplicants = exisitingApplicants.map((applicant, index) => {
        const { fatcadetail = null } = applicants[index] || {};
        const fatcaObj = fatcadetail?.reduce((prev, curr) => {
          if (curr.question_type === 'group' && curr.sub_questions?.length) {
            return { ...prev, ...resetAnswer(curr, _applicants) };
          }
          return (
            curr.backend_key && {
              ...prev,
              [curr.backend_key as string]: '',
            }
          );
          // eslint-disable-next-line
        }, {} as any) as Fatcadetails;

        const finalFatca = fatcadetail?.reduce((prev, curr) => {
          if (
            curr.answer &&
            curr.isVisible &&
            curr.question_type !== 'Controlling_person_details'
          ) {
            return { ...prev, [curr.backend_key as string]: curr.answer };
          }
          if (curr.question_type === 'group' && curr.sub_questions?.length) {
            return { ...prev, ...assignAnswer(curr, _applicants) };
          }
          return prev;
        }, {}) as Fatcadetails;

        return {
          ...applicant,
          typeOfAddressProvidedAtKRA: applicants[index].typeOfAddressProvidedAtKRA || '',
          fatcadetail: {
            ...fatcaObj,
            ...finalFatca,
            id: applicant?.fatcadetail?.id || null,
            applicantId: applicant?.fatcadetail?.applicantId || null,
            entityName: finalFatca.entityName
              ? removeSingleQuote(finalFatca.entityName)
              : fatcaObj.entityName,
            nameOfStockExchange: finalFatca.nameOfStockExchange
              ? removeSingleQuote(finalFatca.nameOfStockExchange)
              : fatcaObj.nameOfStockExchange,
            eIIssuingCountry: finalFatca.eIIssuingCountry
              ? removeSingleQuote(finalFatca.eIIssuingCountry)
              : fatcaObj.eIIssuingCountry,
            eITypeOthers: finalFatca.eITypeOthers
              ? removeSingleQuote(finalFatca.eITypeOthers)
              : fatcaObj.eITypeOthers,
            otherActiveNFEBusiness: finalFatca.otherActiveNFEBusiness
              ? removeSingleQuote(finalFatca.otherActiveNFEBusiness)
              : fatcaObj.otherActiveNFEBusiness,
            otherPassiveNFEBusiness: finalFatca.otherPassiveNFEBusiness
              ? removeSingleQuote(finalFatca.otherPassiveNFEBusiness)
              : fatcaObj.otherPassiveNFEBusiness,
            entityConstitutionType: finalFatca.entityConstitutionType
              ? removeSingleQuote(finalFatca.entityConstitutionType)
              : fatcaObj.entityConstitutionType,
            entityCountryOfResidense: finalFatca.entityCountryOfResidense
              ? removeSingleQuote(finalFatca.entityCountryOfResidense)
              : fatcaObj.entityCountryOfResidense,
            entityCustomerId: finalFatca.entityCustomerId
              ? removeSingleQuote(finalFatca.entityCustomerId)
              : fatcaObj.entityCustomerId,
            nFECountry: finalFatca.nFECountry
              ? removeSingleQuote(finalFatca.nFECountry)
              : fatcaObj.nFECountry,
            nFEntitiesExplanation: finalFatca.nFEntitiesExplanation
              ? removeSingleQuote(finalFatca.nFEntitiesExplanation)
              : fatcaObj.nFEntitiesExplanation,
            fIFatcaCalssifcationOther: finalFatca.fIFatcaCalssifcationOther
              ? removeSingleQuote(finalFatca.fIFatcaCalssifcationOther)
              : fatcaObj.fIFatcaCalssifcationOther,
            fICrsClassificationOther: finalFatca.fICrsClassificationOther
              ? removeSingleQuote(finalFatca.fICrsClassificationOther)
              : fatcaObj.fICrsClassificationOther,
            controllingpersons:
              finalFatca.controllingpersons && finalFatca.controllingpersons.length > 0
                ? finalFatca.controllingpersons
                    .filter((_person) => _person.id || _person.isActive)
                    .map((controllingperson) => {
                      return {
                        ...controllingperson,
                        controllingPersonType: removeSingleQuote(
                          controllingperson.controllingPersonType
                        ),
                        correspondenceAddress: removeSingleQuote(
                          controllingperson.correspondenceAddress
                        ),
                        indentificationType: removeSingleQuote(
                          controllingperson.indentificationType
                        ),
                        name: removeSingleQuote(controllingperson.name),
                        occupationType: removeSingleQuote(controllingperson.occupationType),
                      };
                    })
                : fatcaObj.controllingpersons && fatcaObj.controllingpersons.length > 0
                ? fatcaObj.controllingpersons.filter((person) => person.id || person.isActive)
                : fatcaObj.controllingpersons,
          },
          isTinVerified: applicants[index].tinValidation.map((item, ind) =>
            checkValidationBasedOnDate(
              createdAt || '',
              toggler?.dateFeatureToggles?.tin_declaration_validation_date
            )
              ? isNewFatca
                ? ind === 0 && getValueByPath(applicants[0].fatcadetail, 'Q2.4')?.isVisible
                  ? item.isTinVerified
                  : null
                : IndexToQuestionMapping[ind + incrementCounter].every(
                    (id) => getValueByPath(applicants[0].fatcadetail, id).isVisible
                  ) ||
                  (ind === 2 &&
                    ['Q6.2.4', 'Q9.2.4'].some(
                      (item) => getValueByPath(applicants[0].fatcadetail, item)?.answer === 'No'
                    ))
                ? item.isTinVerified
                : null
              : null
          ),
          documents:
            checkValidationBasedOnDate(
              createdAt || '',
              toggler?.dateFeatureToggles?.tin_declaration_validation_date
            ) && updatedApplicantsWithDoc[0]?.documents?.length
              ? ([
                  ...(applicant?.documents || []),
                  ...updatedApplicantsWithDoc[0].documents,
                ] as DocumentType[])
              : applicant.documents,
        };
      });
      const isSaveLater = saveType !== 'save and proceed';

      const checkApplication = applicationComparison(
        {
          ...application,
          applicants: application?.applicants.map((_applicant) => {
            if (_applicant?.fatcadetail) {
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              const { createdBy, updatedBy, createdAt, updatedAt, ...rest } =
                _applicant.fatcadetail as Fatcadetails;
              return {
                ..._applicant,
                fatcadetail: { ...rest },
              };
            }
            return _applicant;
          }),
        },
        {
          ...application,
          applicants: updatedApplicants,
          currentStep:
            !!currentStep &&
            currentStep >
              getCurrentStep(
                application?.applicationType || '',
                path,
                !!isTopup,
                isSaveLater,
                application?.createdAt,
                toggler
              ) -
                1
              ? currentStep
              : getCurrentStep(
                  application?.applicationType || '',
                  path,
                  !!isTopup,
                  isSaveLater,
                  application?.createdAt,
                  toggler
                ),
          // currentStep:
          //   !!currentStep && currentStep > (RiskProfileEnabled ? 9 : 8)
          //     ? currentStep
          //     : Number(currentStep) + 1,
        }
      );
      if (id && !checkApplication) {
        setLoading(true);
        await dispatch(
          updateApplication({
            body: {
              ...application,
              applicants: updatedApplicants,
              // currentStep: RiskProfileEnabled ? getStep(10, isSaveLater) : getStep(9, isSaveLater),
              currentStep: getCurrentStep(
                application?.applicationType || '',
                path,
                !!isTopup,
                isSaveLater,
                application?.createdAt,
                toggler
              ),
              status: statusRoleBased(role, application),
              ...((!SAVE_LATER_VALIDATION_CHECK as boolean) && { saveForLater: isSaveLater }),
            },
            applicationId: id,
            ...(saveType !== 'save and proceed' && {
              toastMessage: '',
            }),
          })
        );
        history.push(
          navigateToNextStep(
            path,
            role,
            id || '',
            isSaveLater,
            applicant1ReferenceId || '',
            application?.applicationType || '',
            !!isTopup,
            application?.createdAt,
            toggler
          ),
          {
            id,
            applicant1ReferenceId,
            topUpApplication: application?.topupInitiated,
          }
        );
      } else if (checkApplication) {
        if (saveType !== 'save and proceed') {
          enqueueSnackbar(
            `Application ${
              application?.topupInitiated ? topupApplicationNumber : applicationNumber
            } - ` + ' Saved successfully',
            {
              variant: 'success',
              autoHideDuration: 3000,
            }
          );
        }
        history.push(
          navigateToNextStep(
            path,
            role,
            id || '',
            isSaveLater,
            applicant1ReferenceId || '',
            application?.applicationType || '',
            !!isTopup,
            application?.createdAt,
            toggler
          ),
          {
            id,
            applicant1ReferenceId,
            topUpApplication: application?.topupInitiated,
          }
        );
      }
    } catch (e) {
      setLoading(false);
      e instanceof fatcaErrors && dispatch(showError((e as fatcaErrors).message));
      typeof e === 'string' && dispatch(showError(e as string));
      console.error((e as Error).message);
    }
  };

  const isFieldDisabled = [USER_ROLES.AMCAPPROVER].includes(role);
  const isFieldDisabledForPOALogin = [USER_ROLES.POAAPPROVER].includes(role);

  const handleVerification = async (
    values: any,
    index: number,
    verificationCheck: tinValidationProps,
    setValues: (values: any) => void
  ) => {
    const incrementCounter = getValueByPath(values, 'Q6')?.isVisible ? 0 : 4;
    try {
      setLoading(true);
      const questions = IndexToQuestionMapping[index + incrementCounter];
      for (const q of questions) {
        if (!getValueByPath(values, q).answer) {
          return;
        }
      }
      // const taxIdIndex = questions[0].split('Q')[1].split('.');
      // const CountryCodeIndex = questions[1].split('Q')[1].split('.');
      const taxId = getValueByPath(values, questions[0]).answer;
      const countryName = getValueByPath(values, questions[1]).answer;
      const CountryCode = tinCountries?.find(
        (country) => country.countryName.toUpperCase() === countryName.toUpperCase()
      )?.countryCode;
      let idType = 'T';
      if (questions.includes('Q6.1.4') || questions.includes('Q9.1.4')) {
        // const typeIndex = questions[2].split('Q')[1].split('.');
        const idTypeValue = getValueByPath(values, questions[2]).answer;
        idType = tinCode[idTypeValue];
      }
      const res = (await dispatch(
        validateTin({
          TINFormat: 'Legal Entities',
          TINNo: taxId,
          CountryCode: (CountryCode as string) || '',
          IdTypeCode: idType,
          applicantId: application?.applicants?.[0]?.id?.toString() || '',
        })
      )) as unknown as tinValidateResponse;
      setValues((prevValues: Values) => {
        const updatedApplicants = [...prevValues.applicants];
        const applicant = { ...updatedApplicants[0] };
        const updatedTinValidation = [...applicant.tinValidation];

        updatedTinValidation[index] = {
          ...updatedTinValidation[index],
          isTinVerified: res?.isTinVerified,
        };

        applicant.tinValidation = updatedTinValidation;
        applicant.documents = applicant.documents.map((_doc) => {
          if (_doc.documentType === `tin_declaration_${index + 1}`) {
            return {
              ..._doc,
              documentsList: _doc.documentsList.map((d) => ({ ...d, documentId: '' })),
            };
          }
          return _doc;
        });

        updatedApplicants[0] = applicant;

        return {
          ...prevValues,
          applicants: updatedApplicants,
        };
      });
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setLoading(false);
    }
  };
  const handleNewFatcaVerification = async (
    values: any,
    index: number,
    verificationCheck: tinValidationProps,
    setValues: (values: any) => void
  ) => {
    const questions = NewIndexToQuestionMapping[index];
    try {
      setLoading(true);

      if (!getValueByPath(values, 'Q2.4')?.answer) {
        return;
      }

      const taxId = getValueByPath(values, questions[0]).answer;
      const countryName = getValueByPath(values, questions[1]).answer;
      const CountryCode = tinCountries?.find(
        (country) => country.countryName.toUpperCase() === countryName.toUpperCase()
      )?.countryCode;

      let idType = 'T';
      if (questions[2] && getValueByPath(values, questions[2])?.answer) {
        const idTypeValue = getValueByPath(values, questions[2]).answer;
        idType = tinCode[idTypeValue] ?? 'T';
      }

      const res = (await dispatch(
        validateTin({
          TINFormat: 'Legal Entities',
          TINNo: taxId,
          CountryCode: (CountryCode as string) || '',
          IdTypeCode: idType,
          applicantId: application?.applicants?.[0]?.id?.toString() || '',
        })
      )) as unknown as tinValidateResponse;

      setValues((prevValues: Values) => {
        const updatedApplicants = [...prevValues.applicants];
        const applicant = { ...updatedApplicants[0] };
        const updatedTinValidation = [...applicant.tinValidation];

        updatedTinValidation[index] = {
          ...updatedTinValidation[index],
          isTinVerified: res?.isTinVerified,
        };

        applicant.tinValidation = updatedTinValidation;
        applicant.documents = applicant.documents.map((_doc) => {
          if (_doc.documentType === `tin_declaration_${index + 1}`) {
            return {
              ..._doc,
              documentsList: _doc.documentsList.map((d) => ({ ...d, documentId: '' })),
            };
          }
          return _doc;
        });

        updatedApplicants[0] = applicant;

        return {
          ...prevValues,
          applicants: updatedApplicants,
        };
      });
    } catch (e) {
      console.error((e as Error).message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      enableReinitialize={true}
      validateOnChange={false}
      validateOnBlur={true}
      validate={(values: Values) => {
        try {
          validateYupSchema(values, nonIndividualFatcaSchema(mdmsCountriesList), true, values);
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}>
      {({ handleSubmit, values, setValues }) => (
        <Grid
          container
          rowSpacing={1}
          sx={{
            width: '100%',
            ml: 0,
            '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
          }}
          component="form"
          noValidate
          onSubmit={handleSubmit}>
          {values.applicants.map((applicant, idx) => (
            <React.Fragment key={idx}>
              <Grid item xs={12} sm={6}>
                <MFSelectField
                  name={`applicants.${idx}.typeOfAddressProvidedAtKRA`}
                  label="Type of Address Provided At KRA *"
                  items={addressTypesMasters.map((address) => ({
                    key: address,
                    value: address,
                  }))}
                  disabled={isFieldDisabledForPOALogin}
                />
              </Grid>
              {applicant.fatcadetail.map((item) => (
                <React.Fragment key={item.id}>
                  {item.isVisible && item.section_header && item.question_type !== 'group' && (
                    <SectionHeader value={item.section_header} />
                  )}

                  {item.isVisible && item.question_type === 'single_choice_radio' && (
                    <SingleChoiceRadio
                      data={item}
                      values={applicant.fatcadetail}
                      formValuesIndex={idx}
                      questionId={item.id}
                      // disabled={false}
                      disabled={!!application?.topupInitiated}
                    />
                  )}
                  {item.isVisible && item.question_type === 'group' && (
                    <Group
                      data={item}
                      formValuesIndex={idx}
                      values={applicant.fatcadetail}
                      _applicants={values._applicants}
                      // disabled={false}
                      disabled={!!application?.topupInitiated}
                      nationalityDropdown={mdmsCountriesList}
                      setValue={setValues}
                      createdAt={application?.createdAt || ''}
                      tinVerification={applicant.tinValidation}
                      handleVerification={
                        checkValidationBasedOnDate(
                          application?.createdAt || '',
                          gamblingValidationDate
                        )
                          ? handleNewFatcaVerification
                          : handleVerification
                      }
                      tinCountries={tinCountries}
                      documents={applicant.documents}
                      loading={loading}
                      formVal={values}
                      toggler={toggler}
                    />
                  )}
                  {item.isVisible && item.question_type === 'open_text_field' && (
                    <OpenTextField
                      text={item.question_text}
                      applicantsIndex={idx}
                      questionId={item.id}
                      placeHolder={item?.placeholder || 'Please enter text here'}
                      isMandatory={item.isMandatory}
                      // disabled={false}
                      disabled={!!application?.topupInitiated}
                    />
                  )}
                  {item.isVisible && item.question_type === 'bordered_text_field' && (
                    <Grid item xs={12} sm={6} sx={{ pr: { xs: 0, sm: '30px' }, pt: 2 }}>
                      <BorderedTextField
                        applicantsIndex={idx}
                        questionId={item.id}
                        label={item.question_text}
                        placeHolder={item?.placeholder || 'Please enter text here'}
                        isMandatory={item.isMandatory}
                        // disabled={false}
                        disabled={!!application?.topupInitiated}
                      />
                    </Grid>
                  )}
                </React.Fragment>
              ))}
            </React.Fragment>
          ))}
          <FieldValidationNote finalPage={true} />
          <ProceedSaveLater
            saveButtonText={isFieldDisabled ? 'Save Application' : 'Preview'}
            showEndIcon={false}
            saveLater={() => {
              setValues({
                ...values,
                saveType: 'save for later',
              });
            }}
            loader={loading}
            clickedButton={values.saveType}
            showSaveForLater={isFieldDisabled ? false : true}
          />
        </Grid>
      )}
    </Formik>
  );
}
